import React, { useState, useEffect } from "react";
import axios from "axios";
import "./MissingYearlyTargets.css"; // Ensure the CSS matches your file structure
import { useAuth } from "../AuthContext";

const MissingYearlyTargets = () => {
  const { mobile } = useAuth();
  const [customers, setCustomers] = useState([]);
  const [popupMessage, setPopupMessage] = useState("");
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [uniqueEmployees, setUniqueEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("All");

  const showPopupMessage = (message) => {
    setPopupMessage(message);
    setIsPopupVisible(true);
    setTimeout(() => {
      setIsPopupVisible(false);
    }, 4000); // Hide the popup after 3 seconds
  };

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/employee/customers?mobile=${mobile}`
        );
        let filteredAndModifiedCustomers = response.data
          // First, filter out customers with undefined or zero yearly/monthly targets
          .filter(
            (customer) =>
              customer.Yearly_Target > 0 && customer.Monthly_Target > 0
          )
          .map((customer) => ({
            ...customer,
            // Calculate the sales percentage relative to the yearly target
            salesPercentage:
              (customer.Total_Syn_Sales_Yearly /
                (customer.Yearly_Target * 100000)) *
              100,
          }))
          // Then filter customers whose sales are less than 70% of their yearly target and whose total yearly sales are less than the target
          .filter(
            (customer) =>
              customer.salesPercentage > 70 &&
              customer.Total_Syn_Sales_Yearly < customer.Yearly_Target * 100000
          )
          .reduce((acc, current) => {
            const x = acc.find(
              (item) => item.Party_Name === current.Party_Name
            );
            if (!x) {
              return acc.concat([current]);
            } else {
              return acc;
            }
          }, [])
          // Sort customers based on their sales percentage in ascending order
          .sort((a, b) => b.salesPercentage - a.salesPercentage);

        // Extract and sort unique employee names
        let employees = [
          ...new Set(
            filteredAndModifiedCustomers.map((customer) => customer.Employee)
          ),
        ].sort();
        setUniqueEmployees(employees);
        setCustomers(filteredAndModifiedCustomers);
      } catch (error) {
        console.error("Error fetching customers data:", error);
      }
    };

    if (mobile) {
      fetchCustomers();
    }
  }, [mobile]);

  const handleEmployeeFilterChange = (employeeName) => {
    setSelectedEmployee(employeeName);
  };

  const filteredCustomers = customers.filter(
    (customer) =>
      selectedEmployee === "All" || customer.Employee === selectedEmployee
  );

  // Function to copy message to clipboard
  const copyMessageToClipboard = (customer) => {
    const message =
      `*MISSING YEARLY TARGET*\n\n` +
      `Hi,\n\n` +
      `${customer.Party_Name}\n\n` +
      `This side ${customer.Employee} from ${
        customer.Company || "Team Trumac"
      }, Panchkula.\n\n` +
      `Hope you are doing good. This is just a reminder message to remind you that if you don't give additional order you will miss your yearly target by narrow margin.\n\n` +
      `*Yearly Target (Without GST)* : ${Math.round(
        customer.Yearly_Target * 100000
      )}/-\n\n` +
      `*Yearly Incentive* : ${Math.round(
        customer.Yearly_Target * 100000 * 0.03
      )}/-\n\n` +
      `*Your Current Year Purchase (Without GST)* : ${Math.round(
        customer.Total_Syn_Sales_Yearly
      )}/-\n\n` +
      `*Purchase Needed to Complete Target (Without GST)* : ${Math.round(
        customer.Yearly_Target * 100000 - customer.Total_Syn_Sales_Yearly
      )}/-\n\n` +
      `Kindly place your order timely so that you don't miss your yearly incentive.\n\n` +
      `Regards,\n` +
      `${customer.Employee}, ${customer.Company || "Your Company"}\n` +
      `${mobile}`;

    navigator.clipboard.writeText(message).then(
      () => {
        showPopupMessage(`Message Copied to Clipboard..`);
      },
      (err) => {
        console.error("Could not copy text: ", err);
      }
    );
  };

  return (
    <div className="page-container">
      {mobile === "9041677932" && (
        <div className="filter-sidebar">
          <div className="filters-container">
            <h3>Filter by Employee</h3>
            <div>
              <label>
                <input
                  type="radio"
                  name="employeeFilter"
                  value="All"
                  checked={selectedEmployee === "All"}
                  onChange={() => handleEmployeeFilterChange("All")}
                />
                All
              </label>
            </div>
            {uniqueEmployees.map((employee) => (
              <div key={employee}>
                <label>
                  <input
                    type="radio"
                    name="employeeFilter"
                    value={employee}
                    checked={selectedEmployee === employee}
                    onChange={() => handleEmployeeFilterChange(employee)}
                  />
                  {employee}
                </label>
              </div>
            ))}
          </div>
        </div>
      )}
      <div className="customers-container">
        <h1>
          Parties who are going to miss yearly targets
          <span>({filteredCustomers.length} customers)</span>
        </h1>
        <div className="customers-list">
          {filteredCustomers
            .sort((a, b) => b.Avg_Sale - a.Avg_Sale)
            .map((customer) => (
              <div
                key={customer.customer_sale_data_id}
                className="customer-card"
              >
                <div className="customer-name">{customer.Party_Name}</div>
                <div className="customer-details">
                  <div className="customer-info">
                    <p>
                      <strong>{customer.Party_Name}</strong>
                    </p>
                    <p>
                      <strong>Location:</strong>{" "}
                      {`${customer.City}, ${customer.State}`}
                    </p>
                    <p>
                      <strong>Employee:</strong> {customer.Employee}
                    </p>
                  </div>
                  <div className="customer-sales">
                    <p>
                      <strong>Yearly Target (Without GST):</strong>{" "}
                      {Math.round(customer.Yearly_Target * 100000)}
                      /-
                    </p>

                    {/* <p>
                      <strong>Total Sales Yearly (With GST):</strong>{" "}
                      {Math.round(customer.Total_Syn_Sales_Yearly * 1.14)}/-
                    </p> */}

                    <p>
                      <strong>Total Sales Yearly (Without GST):</strong>{" "}
                      {Math.round(customer.Total_Syn_Sales_Yearly)}/-
                    </p>

                    <p>
                      <strong>
                        Sale Needed to Complete Target (Without GST):
                      </strong>{" "}
                      {Math.round(
                        customer.Yearly_Target * 100000 -
                          customer.Total_Syn_Sales_Yearly
                      )}
                      /-
                    </p>
                  </div>
                  <div className="customer-actions">
                    <button
                      className="copy-request-btn"
                      onClick={() => copyMessageToClipboard(customer)}
                    >
                      Copy Yearly Target Message
                    </button>
                  </div>
                </div>
              </div>
            ))}
          {isPopupVisible && (
            <div className="popup-message">{popupMessage}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MissingYearlyTargets;
